import { PUBLIC_SITE_URL } from "$env/static/public";
import { getTemplateCategories } from "design/data/categories";
export function match(param: string) {
  const categories = getTemplateCategories(PUBLIC_SITE_URL);
  return categories.map((c) => c.value).includes(param);
}
